import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBImage } from '@shared/components/image';
import { Link } from '@shared/components/link';
import { LoadingIndicator } from '@shared/components/loading';
import { useLinkData } from '@shared/store/linkData';
import { Colors } from '@shared/styles';
import styles from './LinkPreview.module.css';

interface LinkPreviewProps {
  url: string;
  align: 'left' | 'right';
  isGroupedWithBelow: boolean;
}

export function LinkPreview({ url, align, isGroupedWithBelow }: LinkPreviewProps) {
  const link = useLinkData(url);

  if (!link) {
    return (
      <View center className={styles.linkPreview}>
        <LoadingIndicator />
      </View>
    );
  }

  return (
    <Link href={link.url} underline={false}>
      <View
        className={[
          styles.linkPreview,
          align === 'left' && styles.left,
          align === 'right' && styles.right,
          isGroupedWithBelow && styles.groupedWithBelow,
        ]}
      >
        {!!link.imageUrl && (
          <View center className={styles.imageContainer}>
            <MBImage fill resizeMode="cover" source={{ uri: link.imageUrl }} />
          </View>
        )}

        <View flex paddingVertical={1} paddingHorizontal={1.5}>
          <Text numberOfLines={1} weight="bold">
            {link.title}
          </Text>
          <View fill>
            <Text color={Colors.gray.normal} numberOfLines={2}>
              {link.description}
            </Text>
          </View>
        </View>
      </View>
    </Link>
  );
}
